module.exports = __webpack_public_path__ + "static/error-ig-1-66a3b1b926f4a01c62456e491cfaf153.png";